export default __webpack_public_path__ + "static/media/t size.ddbe0728.jpg";